/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Review2_QuoteInputs */

const es_landing_review2_quote = /** @type {(inputs: Landing_Review2_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Material en perfecto estado y buena atención al cliente, gracias otra vez!`)
};

const gl_landing_review2_quote = /** @type {(inputs: Landing_Review2_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Material en perfecto estado e boa atención ao cliente, grazas outra vez!`)
};

const en_landing_review2_quote = /** @type {(inputs: Landing_Review2_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equipment in perfect condition and great customer service — thanks again!`)
};

/**
* | output |
* | --- |
* | "Equipment in perfect condition and great customer service — thanks again!" |
*
* @param {Landing_Review2_QuoteInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_review2_quote = /** @type {((inputs?: Landing_Review2_QuoteInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Review2_QuoteInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_review2_quote(inputs)
	if (locale === "en") return en_landing_review2_quote(inputs)
	return es_landing_review2_quote(inputs)
});